import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { isValidPasswordFormat } from '../../utils/validations';
import * as authService from '../../services/auth/auth-service';
import * as Loader from '../../common/common';
import { withRouterProps } from '../../common/hocs';

let disable = true;
class ResetPassword extends Component {  
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.checkToken = this.checkToken.bind(this);
    }
    state = {
        resetPassword: {
            password:'',
            token:''
        },
        validationErrors: {},
        msg: '',
        error: '',
        isPassReset: false
    }
    onChange(e) {
        const value = e.target.value;
        const name = e.target.name;
        this.setState({
            resetPassword: {
                ...this.state.resetPassword,
                [name]: value
            }
        });
        let validationErrors = Object.assign({}, this.state.validationErrors);
        if (name === 'password') {
            if (value) {
                if (value.length < 8) {
                    validationErrors.passwordError = 'Password too short'
                }
                else if (!isValidPasswordFormat(value)) {
                    validationErrors.passwordError = 'Password should contain atleast 1 uppercase 1 lowercase 1 digit and 1 special character.'
                }
                else {
                    validationErrors.passwordError = ''
                }
                if (this.state.resetPassword.repeatPassword && this.state.resetPassword.repeatPassword !== value) {
                    validationErrors.repeatPasswordError = 'Password and Repeat Password must be same';
                }
                else {
                    validationErrors.repeatPasswordError = ''
                }
            }
        }
        if (name === 'repeatPassword') {
            if (value) {
                if (this.state.resetPassword.password && this.state.resetPassword.password !== value) {
                    validationErrors.repeatPasswordError = 'Password and Repeat Password must be same';
                }
                else {
                    validationErrors.repeatPasswordError = ''
                }
            }
        }
        this.setState({
            validationErrors: validationErrors
        })
    }
    async onSubmit() {
        Loader.showLoader();
        let { password, repeatPassword } = this.state.resetPassword;
        let { passwordError, repeatPasswordError } = this.state.validationErrors;
        if (password && repeatPassword && !passwordError && !repeatPasswordError) {
            let data = Object.assign({},this.state.resetPassword)
            data.token = this.props.router.params.token;
            let { response, err } = await authService.resetPassword(data);
            Loader.hideLoader();
            if (err) {
                this.setState({
                    resetPassword: {},
                    isPassReset: false,
                    error: response.data.err,
                    msg: ''
                })
            } else if (response.data && response.data.err) {
                this.setState({
                    resetPassword: {},
                    isPassReset: false,
                    error: response.data.err,
                    msg: ''
                })
            } else {
                this.setState({
                    resetPassword: {},
                    isPassReset: true,
                    msg: response.data.msg,
                    error: '',
                })
            }
        }
        else{
            Loader.hideLoader();
        }
    }
    async checkToken() {
        Loader.showLoader();
        let { response, err } = await authService.resetPasswordTokenVerify(this.props.router.params.token);
        Loader.hideLoader();
            if (err) {
                this.setState({
                    error: err,
                    msg: ''
                })
            } else if (response.data && response.data.err) {
                this.setState({
                    error: response.data.err,
                    msg: ''
                })
            } else {
                this.setState({
                    resetPassword: {},
                    msg: response.data.msg,
                    error: '',
                })
            }
    }
    disableButton() {
        let { password, repeatPassword } = this.state.resetPassword;
        let { passwordError, repeatPasswordError } = this.state.validationErrors;
        if (!password || !repeatPassword || passwordError || repeatPasswordError) {
            disable = true
        }
        else {
            disable = false
        }
    }
    componentDidMount() {
        this.checkToken();
    }
    render() {
        this.disableButton();
        let { error, msg, isPassReset } = this.state;
        let { passwordError, repeatPasswordError } = this.state.validationErrors;
        return (
            <React.Fragment>
                {error ?
                    <React.Fragment>
                        <div className="app flex-row align-items-center">
                            <div className="container">
                                <div style={{ textAlign: "center" }}>
                                    <img src="/images/logo.jpg" width="201" height="40" alt="logo" />
                                </div>
                                <p></p>
                                <div className="row justify-content-center">
                                    <div className="col-md-6">
                                        <div className="card mx-4">
                                            <div className="card-body p-4">
                                                <div style={{ textAlign: "center" }}>
                                                    <div>{error}</div>
                                                    <div><Link to="/Login">Go to Login</Link></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </React.Fragment> :
                    null}
                {msg && isPassReset === false ?
                    <div className="app flex-row align-items-center">
                        <div className="container">
                            <div style={{ textAlign: "center" }}>
                                <img src="/images/logo.jpg" width="201" height="40" alt="logo" />
                            </div>
                            <p></p>
                            <div className="row justify-content-center">
                                <div className="col-md-6">
                                    <div className="card mx-4">
                                        <div className="card-body p-4">
                                            <form>
                                                <h1>Reset Password</h1>
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text">
                                                            <i className="icon-lock"></i>
                                                        </span>
                                                    </div>
                                                    <input className={passwordError ? "is-invalid form-control" : "form-control"} type="password" placeholder="Password" name="password" onChange={this.onChange} autoComplete="off"/>
                                                </div>
                                                <div className="form-group">
                                                    <span className="error-msg">{passwordError}</span>
                                                </div>
                                                <div className="input-group mb-4">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text">
                                                            <i className="icon-lock"></i>
                                                        </span>
                                                    </div>
                                                    <input className={repeatPasswordError ? "is-invalid form-control" : "form-control"} type="password" placeholder="Repeat Password" name="repeatPassword" onChange={this.onChange} autoComplete="off"/>
                                                </div>
                                                <div className="form-group">
                                                    <span className="error-msg">{repeatPasswordError}</span>
                                                </div>
                                                <button className="btn btn-block btn-success" type="button" disabled={disable} onClick={this.onSubmit}>Submit</button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> :
                    null}
                {isPassReset ?
                    <React.Fragment>
                        <div className="app flex-row align-items-center">
                            <div className="container">
                                <div className="row justify-content-center">
                                    <div className="col-md-6">
                                        <div className="card mx-4">
                                            <div className="card-body p-4">
                                                <div style={{ textAlign: "center" }}>
                                                    {isPassReset ? <div>Your Password has been changed!</div> : null}
                                                    <div>{error}</div>
                                                    <div><Link to="/Login">Go to Login</Link></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </React.Fragment> :
                    null}
            </React.Fragment>
        );
    }
}

// Custom HOC to inject router props to use React Router v6 hooks in class components
export default withRouterProps(ResetPassword);